import { render, staticRenderFns } from "./HikCamera.vue?vue&type=template&id=48a86048&scoped=true"
import script from "./HikCamera.vue?vue&type=script&lang=js"
export * from "./HikCamera.vue?vue&type=script&lang=js"
import style0 from "./HikCamera.vue?vue&type=style&index=0&id=48a86048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a86048",
  null
  
)

export default component.exports